import { DataResult, State } from '@progress/kendo-data-query';
import { ColumnSettings } from './column-settings.interface';

export interface GridSettings {
  columnsConfig: ColumnSettings[];
  gridData?: DataResult;
  state: State;
}

export class ComponentGridSettings {
  componentName: string;
  customizedSettings?: any;
  gridSettings: GridSettings[];
}

export class FeatureComponentGridSettings {
  componentGridSettings: ComponentGridSettings[];
  featureName: string;
  routerName: string;
}
